/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ContextualTaskBarIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Contextual Task Bar',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m12.75,12h-5.5c-1.24023,0-2.25-1.00977-2.25-2.25v-4.5c0-1.24023,1.00977-2.25,2.25-2.25h5.5c1.24023,0,2.25,1.00977,2.25,2.25v4.5c0,1.24023-1.00977,2.25-2.25,2.25Zm-5.5-7.5c-.41309,0-.75.33691-.75.75v4.5c0,.41309.33691.75.75.75h5.5c.41309,0,.75-.33691.75-.75v-4.5c0-.41309-.33691-.75-.75-.75h-5.5Z"
      fill="currentColor"
      opacity=".35"
      stroke-width="0"
    />
    <path
      d="m16.75,19H3.25c-1.24023,0-2.25-1.00977-2.25-2.25v-.5c0-1.24023,1.00977-2.25,2.25-2.25h13.5c1.24023,0,2.25,1.00977,2.25,2.25v.5c0,1.24023-1.00977,2.25-2.25,2.25Zm-13.5-3.5c-.41309,0-.75.33691-.75.75v.5c0,.41309.33691.75.75.75h13.5c.41309,0,.75-.33691.75-.75v-.5c0-.41309-.33691-.75-.75-.75H3.25Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
